/* eslint-disable no-case-declarations */
import {
    GET_CATEGORIES,
    CategoryActions,
    UPDATE_CATEGORY,
    UPDATE_CATEGORIES
  } from "../../types/actions/Category.actions";
  import { Category } from "../../types/models/Category";
  import { CategoryState } from "../../types/models/CategoryState";
  
  const initialSettings: CategoryState = {
    categories: undefined,
  };
  
  const CategoryReducer = (state = initialSettings, action: CategoryActions) => {
  
    switch (action.type) {
      case GET_CATEGORIES:
        const categories: Category[] | undefined = action.payload;
        return {
          ...state,
          categories: categories
        };
        case UPDATE_CATEGORIES:
          if (state.categories) {
            const updatedCategories = state.categories.map(category =>
              category.Id === action.payload.Id ? action.payload : category
            );
            return {
              ...state,
              categories: updatedCategories,
            };
          }
          return state;
      default:
        return state;
    }
  };
  
  export default CategoryReducer;
  